"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var QuickAccessSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.9805 4.35903L12.9975 4.45026L13.352 8.00001H16.5C16.9754 8.00001 17.1677 8.58694 16.8316 8.87531L16.7573 8.92874L13.632 10.803L13.9975 14.4503C14.0394 14.8691 13.5845 15.1358 13.2452 14.9309L13.1746 14.8796L10.566 12.643L6.75726 14.9288C6.33719 15.1808 5.86295 14.7461 6.03186 14.322L6.07124 14.2428L8.231 10.642L6.17455 8.8796C5.84566 8.59761 6.00986 8.07578 6.4106 8.00746L6.5 8.00001H9.816L12.0713 4.24277C12.3024 3.85751 12.8672 3.9549 12.9805 4.35903ZM12.154 6.04701L10.3821 9.00001L7.849 8.99701L9.52292 10.4322L7.953 13.044L10.6696 11.4146L12.878 13.311L12.5737 10.2716L14.698 8.99901L12.4469 9.00001L12.154 6.04701ZM6 11V12H2V11H6ZM5 7.87531V8.87531H1V7.87531H5ZM7.953 5.04701V6.04701H3.953V5.04701H7.953Z" })));
};
QuickAccessSmall.displayName = 'QuickAccessSmall';
exports.default = QuickAccessSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=QuickAccessSmall.js.map